import React from 'react'
import LimitedViewText from './LimitedViewText'

import image1 from 'images/content-pillar-calendar.png'
import bgHeader from 'images/carousel-2.jpg'
import pdfLogo from 'images/pdf-logo.png'

export default function ContentPillarStrategy2({ limitedView }) {
  const texts = {
    title: 'Content Pillar Strategy',
    description: 'What a busy month could be look like. Planning it ahead allows you to maintain a continuous flow of content about your brand.',
    column1: 'Week 1',
    column2: 'Week 2',
    column3: 'Week 3',
    column4: 'Week 4',
    row1: 'Company / Product News',
    row2: 'Brand Purpose',
    row3: 'Lifestyle',
    row4: 'Timely',
  }

  return (
    <section className="section md-pt4 sm-p0" data-anchor="content-pillar-strategy-2">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box p4 x-lg-p3">
        <div>
          <div className="flex mb2 pt3 sm-p0">
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
          </div>

          <h2 className="persona-sub-title mb3">{texts.title}</h2>

          <p className="fs-18 mb4">{texts.description}</p>

          {limitedView ?
            <LimitedViewText />
            : <img className="sm-hide" src={image1} />
          }
        </div>
      </div>
    </section>
  )
}
